import update from 'immutability-helper';
import * as type from './types';

const defaultState = {
    employees: {
        loaded: false,
        items: []
    },
    employeeApprovers: {
        loaded: false,
        items: [],
    },
    compclasses: {
        loaded: false,
        items: []
    },
    departments: {
        loaded: false,
        items: []
    },
    sections: {
        loaded: false,
        items: []
    },
    batches: {
        loaded: false,
        items: []
    },
    leavetypes: {
        loaded: false,
        items: []
    },
    incomes: {
        loaded: false,
        items: []
    },
    deductions: {
        loaded: false,
        items: []
    },
    periods: {
        loaded: false,
        items: []
    },
    positions: {
        loaded: false,
        items: []
    },
    shifts: {
        loaded: false,
        items: []
    },
    jobs: {
        loaded: false,
        items: []
    },
    joblevels: {
        loaded: false,
        items: []
    },
    salarygrades: {
        loaded: false,
        items: []
    },
    jobclasses: {
        loaded: false,
        items: []
    },
    jobhiring: {
        loaded: false,
        items: []
    },
    applicant: {
        loaded: false,
        items: []
    },
    joapplicant: {
        loaded: false,
        items: []
    },
    joapplicantid: {
        loaded: false,
        items: []
    },
    aisBusinessunits: {
        loaded: false,
        items: []
    },
    aisPositions: {
        loaded: false,
        items: []
    },
    aisProjects: {
        loaded: false,
        items: []
    },
    applicantTokens: {
        loaded: false,
        items: []
    },
    applicantApplied: {
        loaded: false,
        items: []
    },
    interviewee: {
        loaded: false,
        items: []
    },
    interviewers: {
        loaded: false,
        items: []
    },
    positionAccepted: {
        loaded: false,
        items: []
    },
    filteredAddApplicant: {
        loaded: false,
        items: []
    },
    filteredUpdateApplicant: {
        loaded: false,
        items: []
    },
    filteredSearchApplicant: {
        loaded: false,
        items: []
    },
    trainingCategory: {
        loaded: false,
        items: []
    },
    trainingName: {
        loaded: false,
        items: []
    },
    jobTitle: {
        loaded: false,
        items: []
    },
    onboardingType: {
        loaded: false,
        items: []
    },
    onboardingStatus: {
        loaded: false,
        items: []
    },
    onboardingfacilitator: {
        loaded: false,
        items: []
    },
    onboardingprobationary: {
        loaded: false,
        items: []
    },
    schools: {
        loaded: false,
        items: []
    },
    jobsource: {
        loaded: false,
        items: []
    },
    joapprovalstatus: {
        loaded: false,
        items: []
    },
    accesslevel: {
        loaded: false,
        items: []
    },
    erfStatus: {
        loaded: false,
        items: []
    },
    erfTrackerStatus: {
        loaded: false,
        items: []
    },
    hiredCandidate: {
        loaded: false,
        items: []
    },
    civilStatus: {
        loaded: false,
        items: []
    },
    genderDDL: {
        loaded: false,
        items: []
    },
    applicantType: {
        loaded: false,
        items: []
    },
    applicantStatus: {
        loaded: false,
        items: [],
    },
    detailApplicantStatus: {
        loaded: false,
        items: [],
    },
    interviewApplicantStatus: {
        loaded: false,
        item: [],
    },
    intervewResults: {
        loaded: false,
        item: [],
    },
    backgroundCheckStatus: {
        loaded: false,
        item: [],
    },
    jobofferstatus: {
        loaded: false,
        item: [],
    },
    onboardingTrainingStatus: {
        loaded: false,
        item: [],
    },
    educationlevel: {
        loaded: false,
        item: [],
    },
    interviewMode: {
        loaded: false,
        item: [],
    },
    erfrequestType: {
        loaded: false,
        item: [],
    },
    jobpostedstatus: {
        loaded: false,
        item: [],
    },
    equipmentType: {
        loaded: false,
        item: [],
    },
    hiringManager: {
        loaded: false,
        item: [],
    },
    projectLeader: {
        loaded: false,
        item: [],
    },
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case type.UPD_DDL:
            return update(state, {
                [action.payload.name]: {
                    loaded: { $set: true },
                    items: { $set: action.payload.data }
                }
            });
        default: return state;
    }
};
